import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { Form } from 'semantic-ui-react';

const { Input } = Form;

const SearchForm = ({ handleChange, handleSubmit, isSubmitting, values }) =>
    <Form
        onSubmit={handleSubmit}>
        <Input
            autoComplete="off"
            autoFocus
            icon="search"
            iconPosition="left"
            label="Identyfikator sprawy"
            loading={isSubmitting}
            name="case-id"
            onChange={handleChange}
            required
            value={values["case-id"]} />
    </Form>

SearchForm.propTypes = {
    onSubmit: PropTypes.func.isRequired
}

const enhance = withFormik({
    handleSubmit: async (values, { props, setSubmitting }) => {
        try {
            await props.onSubmit(values);
        } finally {
            setSubmitting(false);
        }
    },
    mapPropsToValues: () => ({
        'case-id': ''
    })
})

export default enhance(SearchForm);


// WEBPACK FOOTER //
// ./src/containers/case-statuses/components/SearchForm.js